module.exports = __webpack_public_path__ + "img/main-logo.adba9ea.svg";